import { AUTH_TOKEN } from "shared/constants/auth";
import { IAuthenticated } from "shared/types/Auth";

export const setAuthenticatedUser = ({ auth }: IAuthenticated): void => {
  localStorage.setItem(AUTH_TOKEN, JSON.stringify(auth.data.token));
};
